import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/EmptyPage')({
  component: RouteComponent,
})

function RouteComponent() {
  return(
    <div>Hi</div>
  )
}
